<template>
<div class="chapter">
<div class="inner_page">
<p class="block_4">
<span class="text_2">
</span></p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_2"><span class="text_">Dedication</span></h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_5"><span class="text_2">To my two wonderful children, who now have children of their own.</span></p>
<h1 class="block_6" id="toc_id_3"><span class="text_3"><br class="calibre1" id="calibre_pb_1"/>
</span></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_001.vue?365297e6